import { Col, Image, Row } from 'antd'
import Head from 'next/head'
import Link from 'next/link'
import { useMemo } from 'react'
import CardView from 'src/components/CardView'
import { DotIcon } from 'src/components/CustomIcon'
import { LandingLayout } from 'src/components/Layout/LandingLayout'
import ShowOff from 'src/components/ShowOff'
import BASE_CONFIG from 'src/configs/base'
import commonServices from 'src/services/common.service'
import HOME_DATA from 'src/static/home'

const styles = {
	width: 30,
	float: 'left',
}

const AboutUs = ({ statistics }) => {
	const statisticsArr = useMemo(() => {
		return statistics.map((e) => ({
			id: e.Value,
			url: e.Link,
			value: e.Key,
			key: e.Value,
		}))
	}, [statistics])

	return (
		<div className="aboutus">
			<Head>
				<title>Về chúng tôi | {BASE_CONFIG.SLOGAN}</title>
				<meta name="description" content="Tìm hiểu về 247Express – dịch vụ chuyển phát nhanh uy tín. Chúng tôi luôn đổi mới, sáng tạo và gắn kết để mang đến trải nghiệm trọn vẹn cho khách hàng."></meta>
			</Head>
			<div className="aboutus-banner">
				<Image preview={false} src="/images/about-us-header.jpg" alt="aboutus" />
				<Row className="aboutus-breadcrum">
					<Col>
						<p>VỀ CHÚNG TÔI</p>
						<span>
							<Link href={'/'}>
								<a aria-label={"247Express-Nhanh hơn bạn nghĩ"} style={{ color: 'white' }}>Trang chủ</a>
							</Link>
							<DotIcon
								style={{ transform: 'translateY(-3px)', margin: '0px 5px', color: 'white' }}
							/>
							<span style={{ fontWeight: 600 }}>Về chúng tôi</span>
						</span>
					</Col>
				</Row>
				<Row className="aboutus-title" justify="space-evenly">
					<Col span={20}>
						<span>Nhanh hơn với </span>
						<span style={{ color: 'red' }}>247Express</span>
						<p>
							Chúng tôi xây dựng một doanh nghiệp phát triển bền vững và trách nhiệm qua việc đề cao
							sức Sáng tạo & Đổi mới, thúc đẩy Văn hóa Chiến binh, xây dựng Văn hóa Yêu thương, nuôi
							dưỡng Tinh thần Học hỏi và khuyến khích sự Kết nối - Chia sẻ trong nội bộ cũng như
							hướng đến môi trường bên ngoài.
						</p>
					</Col>
				</Row>
				{/* <ShowOff data={statisticsArr} /> */}
			</div>
			<div className="container">
				<div style={{ marginBottom: 100 }}>
					<CardView
						title="Sứ mệnh doanh nghiệp"
						highlightColor="#CC0000"
						imgUrl="/images/temp_cardview.png"
						content={HOME_DATA.TAM_NHIN_DOANH_NGHIEP}
						link={"#"}
					/>
				</div>
				<div>
					<CardView
						rtl
						title="Giá trị cốt lõi"
						imgUrl="/images/gia-tri-cot-loi.png"
						highlightColor="#CC0000"
						content={HOME_DATA.GIA_TRI_COT_LOI}
						link={"#"}
					/>
				</div>
			</div>
			{/* <div className="aboutus-CEO">
				<div className="container">
					<div className="about-CEO">
						<div className="image-CEO">
							<Image preview={false} src="/images/chu-tich2.png" alt="CEO" />
						</div>
						<div className="text-CEO">
							<div>
								<h1>{HOME_DATA.ABOUT_US_CEO.key}</h1>
								<h3>{HOME_DATA.ABOUT_US_CEO.value}</h3>
								<p>{HOME_DATA.ABOUT_US_CEO.descript}</p>
							</div>
						</div>
					</div>
				</div>
			</div> */}
		</div>
	)
}

AboutUs.Layout = LandingLayout

export const getStaticProps = async () => {
	const statistics = await commonServices.getStatistics()

	return { props: { statistics: statistics.Data }, revalidate: true }
}

export default AboutUs
